<template>
  <div class="wrap-bg wrap-data-manage wrap-content-detail pd15">
    <v-breadcrumb v-if="isShowBread" :breadcrumb-list="breadcrumbList" />
    <div
      v-loading="isLoad"
      element-loading-text="加载中"
      element-loading-spinner="el-icon-loading"
      class="bg-white main-con breadcrumb-btm-con-box">
      <h3 class="f-fwn bor-btm-gray pd-column10-row15 f-fs16">{{ baseInfoObj.title }}</h3>
      <!-- 内容编辑模块 -->
      <manage-edit
        ref="manageEdit"
        :form-arr="formArr"
        :page-type="paramObj.type"
        @formItemEdit="formItemEdit"
        @componentChange="componentChange"
        @saveBtn="saveBtn"
        @cancelBtn="cancelBtn" />
    </div>
  </div>
</template>

<script>
import vBreadcrumb from '@/components/breadcrumb.vue'
import manageEdit from '@/components/manageEdit.vue'
import $filterCommon from '@/components/form-filter/index.js'
import pageConfig from './page.config'
import mixin from '@/mixin/manageEdit'
import {
  getDetailInfo,
  addContent,
  updateContent
} from '@/api/dataManage/content.js'
export default {
  components: {
    vBreadcrumb,
    manageEdit
  },
  mixins: [mixin],
  data() {
    return {
      isShowBread: false,
      breadcrumbList: [
        {
          name: '数据管理'
        },
        {
          name: '内容数据管理',
          path: '/dataManage/list'
        },
        {
          name: '详情'
        }
      ],
      isLoad: false,
      paramObj: {}, // 详情参数
      baseInfoObj: {
        title: '新增内容数据'
      },
      formArr: [],
      chinaData: [],
      foreignData: []
    }
  },
  created() {
    // console.log(this.$store.state.userInfo)
    // 获取参数
    this.paramObj = this.$route.query
    // 页面表单修改内容初始化初始化
    this.formArr = this.formInt(pageConfig.detailInfos)
    // 页面初始化
    if (this.paramObj.type === 'add') {
      this.breadcrumbList[this.breadcrumbList.length - 1].name = '新增'
      this.init()
    } else {
      this.getDetailInfo(this.paramObj, data => {
        this.init(data)
      })
    }
  },
  methods: {
    init() {
      this.isLoad = true
      // 请求所有条件
      const filterAjaxList = JSON.parse(JSON.stringify(pageConfig.filterAjaxList))
      Promise.all(filterAjaxList.map(item => $filterCommon.getLabelCommon(item.method, item.url, item.param, item))).then(data => {
        this.isLoad = false
        // 拿到数据之后数据处理
        this.formArr = this.ajaxFinishInt(data, this.formArr)
        // 如果是新增，默认基础信息打开编辑
        if (this.paramObj.type === 'add') this.formItemEdit(this.formArr[0], 0)
      })
    },
    // 获取基本信息
    getDetailInfo(paramObj, cb) {
      this.isLoad = true
      getDetailInfo({
        articleId: paramObj.id
      }).then(res => {
        this.isLoad = false
        const data = res.data || {}
        // 地区处理
        console.log(data.authCountry)
        let autoArea = []
        if (data.authCountry && data.authCountry !== '-') {
          if (data.authCountry === '中国') {
            autoArea = [data.authCountry]
            if (data.authProvince && data.authProvince !== '-') autoArea.push(data.authProvince)
            if (data.authCity && data.authProvince !== '-') autoArea.push(data.authCity)
            data.autoArea = autoArea
          } else {
            autoArea = ['国外', data.authCountry]
            data.autoArea = autoArea
          }
        }
        data.autoArea = autoArea
        // 保存原始值
        this.baseInfoObj = {}
        for (const key in data) {
          this.baseInfoObj[key] = data[key] || ''
        }
        this.breadcrumbList[this.breadcrumbList.length - 1].name = this.baseInfoObj.title
        // 赋值
        this.formArr.forEach(item => {
          if (item.infosList && item.infosList.length) {
            item.infosList.forEach(elem => {
              // 处理带有单位的回显
              let val = data[elem.key] || elem.initVal || ''
              if (elem.isParamAddUnit && elem.unit && val) val = val.replace(elem.unit, '')
              // 初始化值
              elem.value = val
              elem.inpVal = elem.value || ''
            })
          }
          return item
        })
        cb && cb(data)
      })
    },
    // 下拉修改
    componentChange($event, item, flag, pIndex) {
      // // 如果是取消，则找到原来值重新请求
      // let initVal = ''
      // if (flag === 'cancle') {
      //   if (targetItem) {
      //     const findItem = targetItem.children.find(elem => elem.id === targetItem.value) || {}
      //     initVal = item.isValueTxt ? findItem.name : findItem.id
      //   }
      // }
      // // console.log(initVal)
      // 关联目标对象数组解析
      if (!item.relatedKey) return
      const relatedKeys = item.relatedKey.split(',') || []
      relatedKeys.forEach(relatedKey => {
        // 找到关联目标对象
        const targetItem = this.targeFind(relatedKey)
        // 开始计算
        // 关联字段自动计算
        if (relatedKey === 'pubDate') {
          // 发布日期
          targetItem.inpVal = $event ? $event.substr(0, 10) : $event
        } else if (relatedKey === 'interactNum' || relatedKey === 'totalCost') {
          // 互动量 = 点赞量 + 收藏量 + 评论量
          // 费用成本(元)=搜索信息流花费+品牌广告花费+合作价格
          targetItem.inpVal = this.formArr[pIndex].infosList.reduce((sum, elem) => {
            if (elem.relatedKey === relatedKey) {
              sum += (elem.inpVal * 1) || 0
            }
            return sum
          }, 0)
          // 如果是费用成本，则保留两位
          if (relatedKey === 'totalCost') targetItem.inpVal = targetItem.inpVal ? targetItem.inpVal.toFixed(2) : '0.00'
        } else if (relatedKey === 'interactRate') {
          // 互动率 = 互动量 / 阅读量 * 100%
          // 阅读量
          const readObj = this.targeFind('readNum')
          // 互动量
          const interactObj = this.targeFind('interactNum')
          // 互动率就算
          const val = readObj.inpVal ? (interactObj.inpVal || 0) / readObj.inpVal * 100 : 0
          targetItem.inpVal = val.toFixed(2) + '%'
        } else if (relatedKey === 'followerLevel' || relatedKey === 'cpeCostLevel' || relatedKey === 'cpvCostLevel' || relatedKey === 'totalCostLevel') {
          // 粉丝量级, CPE层级, CPV层级, 费用成本层级
          const levelObj = targetItem.children.find(elem => elem.min <= $event && elem.max >= $event) || targetItem.children[0]
          targetItem.inpVal = levelObj.name
        } else if (relatedKey === 'cpeCost') {
          // CPE(元)=费用成本(元)/互动量
          // 互动量
          const interactObj = this.targeFind('interactNum')
          // 费用成本
          const totalCostObj = this.targeFind('totalCost')
          // 计算CPE成本
          const val = interactObj.inpVal ? (totalCostObj.inpVal || 0) / interactObj.inpVal : 0
          targetItem.inpVal = val.toFixed(2)
        } else if (relatedKey === 'cpvCost') {
          // CPV(元) = 费用成本(元) / 阅读量
          // 阅读量
          const readObj = this.targeFind('readNum')
          // 费用成本
          const totalCostObj = this.targeFind('totalCost')
          // 计算CPE成本
          const val = readObj.inpVal ? (totalCostObj.inpVal || 0) / readObj.inpVal : 0
          targetItem.inpVal = val.toFixed(2)
        }
        // 如果关联字段还有关联对象则再次调用
        if (targetItem.relatedKey) this.componentChange(targetItem.inpVal, targetItem, flag, pIndex)
      })
    },
    // 保存按钮
    saveBtn(item, index) {
      const getParamObj = this.saveParam(item, index)
      // 如果返回false或者没有被修改过，则直接终止
      if (!getParamObj || !getParamObj.isInsert) return
      // 整理保存参数
      const param = Object.assign({
        userId: this.$store.state.userInfo.userId, // 当前用户id
        userName: this.$store.state.userInfo.userName, // 当前用户name
        articleId: this.baseInfoObj.articleId || '',
        updateType: item.updateType
      }, getParamObj.param)
      // 地区字段
      if (param.autoArea && param.autoArea.length) {
        const areas = param.autoArea.split(',')
        if (areas[0] === '中国') {
          param.authCountry = areas[0]
          param.authProvince = areas.length > 1 ? areas[1] : ''
          param.authCity = areas.length > 2 ? areas[2] : ''
        } else {
          param.authCountry = areas[areas.length - 1]
        }
      }
      // 开始请求保存接口
      console.log(JSON.stringify(param))
      this.saveModelInfo(param, item, index)
    },
    // 保存接口
    saveModelInfo(param, item, index) {
      if (this.baseInfoObj.articleId) {
        updateContent(param).then(res => {
          this.saveSuccessAfterHandle(item, index, param, res)
        })
      } else {
        addContent(param).then(res => {
          this.saveSuccessAfterHandle(item, index, param, res)
        })
      }
    },
    // 保存后处理
    saveSuccessAfterHandle(item, index, param, res) {
      item.isSaveLoading = true
      setTimeout(() => {
        item.isSaveLoading = false
        const data = res.data || {}
        if (data.message.indexOf('成功') >= 0) {
          // 同步更新列表
          this.baseInfoObj.articleId = data.data || this.baseInfoObj.articleId || ''
          // 如果是保存第一个模块则查看标题修改
          if (item.updateType * 1 === 1) {
            this.baseInfoObj.title = param.title || this.baseInfoObj.title
          }
          // 添加后都是修改
          this.paramObj.type = 'edit'
          this.$bus.$emit('updateContentList')
          // 成功之后回调
          this.saveSuccessfn(item, index, param)
        } else {
          this.$message({
            type: 'error',
            message: data.message || '保存失败！'
          })
        }
      }, 1500)
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/color.less';
</style>
